
import Schema from 'AppReact/schema';
import { cardItem, assignTech, assignVendor, admin, makeReadyColumn } from 'types';
import { selectedItem, selectedCatgegory } from '../../apps/admin/makeReadyBoard/types'

export default {
  item: Schema(cardItem, 'object', { defaultValue: Schema(cardItem).sampleData() }),
  isOpen: Schema('boolean', 'primitive', { defaultValue: false }),
  shouldOpen: Schema('boolean', 'primitive', { defaultValue: true }),
  containerRef: Schema({}, 'object', { defaultValue: null }),
  techs: Schema(assignTech, 'array', { defaultValue: [] }),
  vendors: Schema(assignVendor, 'array', { defaultValue: [] }),
  admins: Schema(admin, 'array', { defaultValue: [] }),
  activeAdmins: Schema(admin, 'array', { defaultValue: [] }),
  displayNoteInput: Schema('boolean', 'primitive', { defaultValue: true }),
  displayConfetti: Schema('boolean', 'primitive', { defaultValue: false }),
  selectedRow: Schema('boolean', 'primitive', { defaultValue: false }),
  isSelected: Schema('boolean', 'primitive', { defaultValue: false }),
  displayNotes: Schema('boolean', 'primitive', { defaultValue: false }),
  top: Schema('string', 'primitive', { defaultValue: '54px' }),
  left: Schema('string', 'primitive', { defaultValue: '0px' }),
  bottom: Schema('string', 'primitive', { defaultValue: '' }),
  makeReadyCategory: Schema(makeReadyColumn, 'object', { defaultValue: {} }),
  showCheckboxes: Schema('boolean', 'primitive', { defaultValue: false }),
  hideCheckbox: Schema('boolean', 'primitive', { defaultValue: false }),
  selectedItems: Schema(selectedItem, 'array', { defaultValue: [] }),
  selectedCategories: Schema(selectedCatgegory,'array', { defaultValue: [] }),
}
